import { TableCell, TableRow } from ".";
import { cx } from "@/lib/tailwind-utils";
export default function PlaceholderRow({
  rows,
  headers
}: {
  rows: number;
  headers: number;
}) {
  return Array.from({
    length: rows
  }).map((_, index) => <TableRow key={index}>
      {Array.from({
      length: headers
    }).map((_, index) => <TableCell key={index}>
          <div className={cx("flex animate-pulse py-3", index === 0 && "pl-0", index === headers - 1 && "pr-0")}>
            <div className="h-4 rounded bg-muted" style={{
          width: `${90 + index % 2 * 10}%`
        }}></div>
          </div>
        </TableCell>)}
    </TableRow>);
}